import { render, staticRenderFns } from "./partnersTable.vue?vue&type=template&id=3a57bc25&"
import script from "./partnersTable.vue?vue&type=script&lang=ts&"
export * from "./partnersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports